import { Input } from '@grupoboticario/flora-react';
import { Controller, useFormState } from 'react-hook-form';
import { InputFormProps } from './types';

export function InputForm({
  control,
  name,
  label,
  id,
  required = false,
  placeholder,
  type = 'text',
  mask = undefined,
  maxLength = undefined,
}: Readonly<InputFormProps>) {
  const { errors } = useFormState({
    control,
  });

  const inputError = errors[name]?.message.toString();

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({ field }) => (
        <Input
          mask={mask}
          label={label}
          id={id}
          status={inputError ? 'error' : 'neutral'}
          helperText={inputError}
          placeholder={placeholder}
          type={type}
          required={required}
          value={field.value}
          maxLength={maxLength}
          autoComplete="off"
          {...field}
        />
      )}
    />
  );
}
